import CircularProgress from '@mui/material/CircularProgress';
import Container from "@mui/material/Container";
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Autocomplete, {
  createFilterOptions,
} from "@mui/material/Autocomplete";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams  } from "react-router-dom";
import {
  NotificationManager,
} from "react-notifications";
import InviteCandidateDetailsResponse from "../../apis/inviteCandidate/inviteCandidateDetails";
import getAllTests from "../../apis/Tests/getAllTests";
import {jwtDecode}  from "jwt-decode";
import phoneNumberExistResponse from "../../apis/users/getUserDataByPhoneNumber";
import HomeContactUsModal from "../../pages/home/homeHeader/homeContactUsModal/homeContactUs";
import recruiter_header_logo from "../../components/basicInfoForm/images/logo_recruiter_header.png";
import "react-phone-number-input/style.css";
import PhoneInput, { isPossiblePhoneNumber, parsePhoneNumber } from "react-phone-number-input";
import GetUserById from "../../apis/users/getUserById";
import fetchCountryStateCity from "../../apis/fetchCountryStateCity";
import Footer from '../adminFooter/Footer';


const filterTestOptions = createFilterOptions({
  matchFrom: "start",
  stringify: (option) => option.testName,
});
const styles = {
  testQuestAnsCard: {
    height: '66vh',
    maxWidth: 'none',
    mt: '20px',
    pt: '70px',
    boxShadow:
      'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
  },
};

const RecruiterSignUp = (props) => {
  const params = useParams();
  const history = useNavigate();
  const [isTermsAccepted, setIsTermsAccepted] = useState(false);
  const isActive = false;
  const [counter, setCounter] = useState(300000);
  const [IsbtnDisabled, setIsbtnDisabled] = useState(true);

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const MiddleInitial = "";
  const [skillId, setskillId] = useState("");
  const subSill = [];
  const [defaultTest, setDefaultTest] = useState({});
  const [allTests, setAllTests] = useState([]);
  const [isLinkValid, setIsLinkValid] = useState(false);
  const [isPageDisplay, setIsPageDisplay] = useState(false);
  const [recruitmentpartnerId, setRecruitmentPartnerId] = useState("");
  const hamburger = useRef(0);
  const [open, setOpen] = useState(false);
  const [hamburgerIsClicked, setHamburgerIsClicked] = useState(false);
  const [recruiterId, setRecruiterId] = useState("");

  // New state structure
  const [locationList, setLocationList] = useState({
    countryList: [],
    stateList: [],
    cityList: [],
    isCountryFetching: false,
    isStateFetching: false,
    isCityFetching: false,
  });

  const [userInformation, setUserInformation] = useState({
    locationCountry: {},
    locationState: {},
    locationCity: {},
    phoneNumber: "",
    countryCode: "",
    isValidPhoneNumber: false,
    defaultCountryCode: "",
  });

  const fetchLocationInformation = async (field) => {
    if (field === "country") {
      setLocationList((prev) => ({
        ...prev,
        isCountryFetching: true,
      }));
      try {
        let payload = {
          actionName: "country"
        }

        let response = await fetchCountryStateCity(payload)
        if (response.status === 200) {
          setLocationList((prev) => ({
            ...prev,
            isCountryFetching: false,
            countryList: response.data.data
          }))
        }
      } catch (error) {
        NotificationManager.error(
          "Unable to load country list. Please try again later.",
          "Error",
          10000
        )
        setLocationList((prev) => ({
          ...prev,
          isCountryFetching: false,
          countryList: [],
        }));
      }
    }
    else if (field === "state") {
      setLocationList((prev) => ({
        ...prev,
        isStateFetching: true,
      }));
      try {
        let payload = {
          actionName: "state",
          countryCode: userInformation.locationCountry.isoCode
        }

        let response = await fetchCountryStateCity(payload)
        if (response.status === 200) {
          setLocationList((prev) => ({
            ...prev,
            isStateFetching: false,
            stateList: response.data.data
          }))
        }
      } catch (error) {
        NotificationManager.error(
          "Unable to load state list. Please try again later.",
          "Error",
          10000
        )
        setLocationList((prev) => ({
          ...prev,
          isStateFetching: false,
          stateList: [],
        }));
      }
    }
    else if (field === "city") {
      setLocationList((prev) => ({
        ...prev,
        isCityFetching: true,
      }));
      try {
        let payload = {
          actionName: "city",
          stateCode: userInformation.locationState.isoCode,
        }

        let response = await fetchCountryStateCity(payload)
        if (response.status === 200) {
          setLocationList((prev) => ({
            ...prev,
            isCityFetching: false,
            cityList: response.data.data
          }))
        }
      } catch (error) {
        NotificationManager.error(
          "Unable to load city list. Please try again later.",
          "Error",
          10000
        )
        setLocationList((prev) => ({
          ...prev,
          isCityFetching: false,
          cityList: [],
        }));
      }
    }
  }

  useEffect(() => {
    animateBubble();
  }, []);

  useEffect(() => {
    let intervalId;
    if (isActive) {
      intervalId = setInterval(() => {
        if (counter > 0) {
          setCounter((counter) => counter - 1000);
        }
      }, 1000);
    }
    return () => clearInterval(intervalId);
  }, [isActive, counter]);

  useEffect(() => {
    getTests();
  }, []);

  useEffect(() => {
    getInviteCandidateDetailsResponse(params.id);
  }, []);

  const getInviteCandidateDetailsResponse = async (id) => {
    try {
      let CandidateDetails = await InviteCandidateDetailsResponse({ id: id });

      if (!CandidateDetails.data.isexistingcandidate) {
        if (CandidateDetails.data.data && CandidateDetails.data.data.length > 0) {
          setRecruiterId(CandidateDetails.data.data[0].invitedBy)
          setFirstName(CandidateDetails.data.data[0].firstName);
          setLastName(CandidateDetails.data.data[0].lastName);
          setEmail(CandidateDetails.data.data[0].email);
          setskillId(CandidateDetails.data.data[0].test.skillId);
          setDefaultTest(CandidateDetails.data.data[0].test);

          if (CandidateDetails.data.data[0]?.test?.recruitmentpartnerId === "") {
            const res = await GetUserById(CandidateDetails.data.data[0]?.invitedBy)
            setRecruitmentPartnerId(res?.data?.data[0]?.recruitmentpartner?.id)
          }
          else {
            setRecruitmentPartnerId(CandidateDetails.data.data[0]?.test?.recruitmentpartnerId)
          }

          setIsLinkValid(true);
        }
      }
      else {
        let token = localStorage.getItem("token")
        if (token) {
          jwtDecode(token);

          history("/invitedtest-landing",
            {
              state: {
                inviteId: params.id
              }
            });
        }
        else {
          history("/signIn",
            {
              state: {
                test: CandidateDetails.data.data[0].test,
                isRedrictedFromIvite: true,
                pageName: "/invite/" + params.id,
                inviteId: params.id
              }
            });
        }
      }
    } catch {
      setIsPageDisplay(true);
    }
  };

  const validateEmail = (email) => {
    const regX =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (regX.test(email)) {
      if (
        email.includes("gmail") ||
        email.includes("outlook") ||
        email.includes("yahoo") ||
        email.includes("hotmail")
      ) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  };

  const emailChangeHandler = (event) => {
    const emailValue = event.target.value;
    validateEmail(emailValue);
  };

  const animateBubble = () => {
    setTimeout(() => {
    }, 100);
  };

  const gotoHomePage = (e) => {
    history("/");
  };

  const goToTerms = (e) => {
    window.open("/terms-of-use");
  };

  const goToPrivacyPolicy = () => {
    window.open("/privacy-policy");
  };

  const countryHandler = (event, value) => {
    if (value) {
      setUserInformation({
        ...userInformation,
        locationCountry: value,
        defaultCountryCode: value.isoCode,
        locationState: {},
        locationCity: {},
      });
      setLocationList((prev) => ({
        ...prev,
        stateList: [],
        cityList: [],
      }));
    }
    else {
      setUserInformation({
        ...userInformation,
        locationCountry: {},
        defaultCountryCode: "",
        locationState: {},
        locationCity: {},
      })
      setLocationList((prev) => ({
        ...prev,
        stateList: [],
        cityList: [],
      }));
    }
  };

  const stateHandler = (event, value) => {
    if (value) {
      setUserInformation({
        ...userInformation,
        locationState: value,
        locationCity: {},
      })
      setLocationList((prev) => ({
        ...prev,
        cityList: []
      }));
    }
    else {
      setUserInformation({
        ...userInformation,
        locationState: {},
        locationCity: {},
      })
      setLocationList((prev) => ({
        ...prev,
        cityList: []
      }));
    }
  };

  const cityHandler = async (event, value) => {
    setUserInformation({
      ...userInformation,
      locationCity: value || {}
    })
  };

  const phoneNumberChangeHandler = (val) => {
    if (val) {
      try {
        const parsedPhone = parsePhoneNumber(val);
        let isValidPhoneNumber = false;

        if (val && isPossiblePhoneNumber(val)) {
          isValidPhoneNumber = true;
        }
        else {
          isValidPhoneNumber = false;
        }

        setUserInformation({
          ...userInformation,
          phoneNumber: parsedPhone?.nationalNumber || val,
          countryCode: parsedPhone?.countryCallingCode ? `+${parsedPhone.countryCallingCode}` : "",
          isValidPhoneNumber: isValidPhoneNumber
        })
      } catch (error) {
        console.log("Phone number parsing error:", error);
        setUserInformation({
          ...userInformation,
          phoneNumber: val,
          countryCode: "",
          isValidPhoneNumber: false
        })
      }
    }
    else {
      setUserInformation({
        ...userInformation,
        phoneNumber: "",
        countryCode: "",
        isValidPhoneNumber: false
      })
    }
  };

  const firstNameChangeHandler = (e) => {
    let firstName = e.target.value;
    setFirstName(firstName);
  };

  const lastNameChangeHandler = (e) => {
    let lastName = e.target.value;
    setLastName(lastName);
  };

  const keypressHandler = (e) => {
    var invalidChars = ["-", "+", "e"];
    if (invalidChars.includes(e.key)) {
      e.preventDefault();
    }
  };

  const TermsCheckboxHandler = (e) => {
    setIsTermsAccepted(e.target.checked);
    if (e.target.checked === true) {
      setIsbtnDisabled(false);
    } else {
      setIsbtnDisabled(true);
    }
  };

  const testChange = async (event, value) => {
    if (value) {
      setDefaultTest(value);
    } else {
      setDefaultTest({});
    }
  };

  const checkPhoneNumber = async (phoneNumber) => {
    var phoneNumberInput = {
      phoneNumber: phoneNumber,
    };
    try {
      const phoneNochkResponse = await phoneNumberExistResponse(
        phoneNumberInput
      );
      if (phoneNochkResponse.data.data[0].isUnique === true) {
        return phoneNochkResponse.data.data[0].isUnique;
      }
    } catch (error) {
      console.log("phonenoresponse", error);
    }
  };

  const getTests = async () => {
    try {
      const res = await getAllTests();
      const data = res.data;
      setAllTests(data.data);
      animateBubble();
    } catch (error) {
      console.log(error.response.data);
    }
  };

  const updateProfileData = async (e) => {
    e.preventDefault();
    if (
      firstName === "" ||
      lastName === "" ||
      email === "" ||
      Object.keys(defaultTest).length === 0 ||
      !userInformation.locationCountry?.name ||
      !userInformation.locationState?.name
    ) {
      return NotificationManager.error(
        "Please fill all required fields",
        "Error",
        10000
      );
    }
    if (IsbtnDisabled) {
      return NotificationManager.error(
        "Please agree to terms of use & privacy policy to continue",
        "Error",10000
      );
    }
    if (!userInformation.isValidPhoneNumber && userInformation.phoneNumber) {
      return NotificationManager.error(
        "Please enter a valid phone number",
        "Error",
        10000
      );
    }
    if (userInformation.phoneNumber !== "") {
      const isunique = await checkPhoneNumber(userInformation.phoneNumber);
      if (!isunique) {
        return NotificationManager.error(
          "Phone number already exists in our system",
          "Error",
          10000
        );
      }
    }
    history("/test-landing",
      {
        state: {
          firstName,
          lastName,
          MiddleInitial,
          phoneNumber: userInformation.phoneNumber ? userInformation.phoneNumber : "",
          countryCode: userInformation.countryCode,
          email,
          locationCountry: JSON.stringify(userInformation.locationCountry),
          locationState: JSON.stringify(userInformation.locationState),
          locationCity: JSON.stringify(userInformation.locationCity),
          skillId: skillId,
          subSkillsJson: subSill,
          test: defaultTest,
          recruitmentpartnerId: recruitmentpartnerId,
          pageName: "/invite/" + params.id,
          inviteId: params.id,
          recruiterId
        }
      });
  };

  const hamburgerClicked = () => {
    setHamburgerIsClicked(!hamburgerIsClicked)
  }

  const openSupportModal = () => {
    setOpen(true);
  }

  const _modalClose = () => {
    setOpen(false);
  }

  return (
    <>
      {isLinkValid ? (
        <>
          <div className="mainContainer_reg">
            <div className="topContainer">
              <div className="nav_bg_home home-specific-header">
                <div className="container w1200 nav_bg_home_section">
                  <div className="nav_bg_left">
                    <li className='cp headerListStyleNone' onClick={() => gotoHomePage()}>
                      <div><img src={recruiter_header_logo} className="nav_logo_home" alt='img' /></div>
                    </li>
                  </div>
                  <div className="nav_bg_right">
                    <ul className="navbar_home">
                      <li className="special_hover cp" onClick={openSupportModal}><>Contact Us</></li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className='nav_bg_home_responsive'>
                <div className="nav_bg_home_responsive-wrapper">
                  <div className="home-top-nav">
                    <li className='cp headerListStyleNone' onClick={() => gotoHomePage()}>
                      <div><img src={recruiter_header_logo} className="nav_logo_home" alt='img' /></div>
                    </li>
                    <div className={hamburgerIsClicked ? "hamburgerIsClicked" : "hamburgerIsNotClicked"} ref={hamburger}>
                      <ul className="navbar_home-responsive">
                        <li className="special_hover cp" onClick={openSupportModal}><>Contact Us</></li>
                      </ul>
                    </div>
                    <div className="icon" onClick={hamburgerClicked}>
                      <i className="fa fa-bars"></i>
                    </div>
                  </div>
                </div>
              </div>
              <Grid container className="mainDiv_reg">
                <Grid size={{ xs: 12 }}>
                  <div className="rightHeading_inviteTest"> Complete Registration & Take Test</div>
                </Grid>
                <Grid size={{ sm: 6 }}>
                  <div className="leftContainer">
                    <div className="leftHeading"> Please read the instructions below before you start test</div>
                    <p className="left_points">
                      <span className="leftBullets">1.</span> For multiple choice questions, you may be allowed to pick just one answer choice or multiple. The clock starts as soon as you click <span className="leftBullets">"Start Test"</span> so start <span className="leftBullets">ONLY</span> when you are ready.
                    </p>
                    <p className="left_points">
                      <span className="leftBullets">2.</span> Some questions may have two parts. For example, Part 1 may be an open ended question where you are expected to speak out your response on video for 1 minute and Part 2 may be a multiple choice question where you are expected to pick the correct answer(s) from the options provided.
                    </p>
                    <p className="left_points">
                      <span className="leftBullets">3.</span> You will be video recorded during the test so please ensure your camera is active and focusing on you.
                    </p>
                    <p className="left_points">
                      <span className="leftBullets">4.</span> Please note that at no point during the test you can go back to the previous question.
                    </p>
                    <p className="left_points">
                      <span className="leftBullets">5.</span> Please try not to navigate out of the test window (or open other applications) for the test duration. We detect such movements and report them to the reviewer.
                    </p>
                  </div>
                </Grid>
                <Grid size={{ sm: 6 }}>
                  <div className="rightContainer">
                    <Grid container spacing={1}>
                      <Grid size={{ xs: 12, md: 6 }} >
                        <div className="inputLabel_right">First Name*</div>
                        <FormControl fullWidth variant="outlined">
                          <OutlinedInput
                            placeholder="Please Enter Your First Name"
                            className="admin_textbox"
                            value={firstName}
                            onChange={(e) => firstNameChangeHandler(e)}
                          />
                        </FormControl>
                      </Grid>
                      <Grid size={{ xs: 12, md: 6 }}>
                        <div className="inputLabel_right">Last Name*</div>
                        <FormControl fullWidth variant="outlined">
                          <OutlinedInput
                            placeholder="Please Enter Your Last Name"
                            className="admin_textbox"
                            value={lastName}
                            onChange={lastNameChangeHandler}
                          />
                        </FormControl>
                      </Grid>
                      <Grid size={{ xs: 12, md: 6 }}>
                        <div className="inputLabel_right">Email*</div>
                        <FormControl fullWidth variant="outlined">
                          <OutlinedInput
                            className="admin_textbox"
                            placeholder="Enter Email"
                            value={email}
                            onChange={(event) => emailChangeHandler(event)}
                            disabled
                          />
                        </FormControl>
                      </Grid>
                      <Grid size={{ xs: 12, md: 6 }}>
                        <div className="inputLabel_right">Country*</div>
                        <Autocomplete
                          id="combo-box-demo"
                          className="mt_14"
                          options={locationList.countryList}
                          autoHighlight
                          getOptionLabel={(option) => option.name || ""}
                          filterSelectedOptions
                          value={userInformation.locationCountry}
                          onChange={countryHandler}
                          loading={locationList.isCountryFetching}
                          onFocus={() => locationList.countryList.length > 0 ? null : fetchLocationInformation("country")}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              required={true}
                              placeholder="Select country"
                              slotProps={{
                                input: {
                                  ...params.InputProps,
                                  endAdornment: (
                                    <>
                                      {locationList.isCountryFetching ? <CircularProgress color="inherit" size={20} /> : null}
                                      {params.InputProps.endAdornment}
                                    </>
                                  ),
                                },
                              }}
                            />
                          )}
                        />
                      </Grid>
                      <Grid size={{ xs: 12, md: 6 }}>
                        <div className="inputLabel_right">Phone Number</div>
                        <div className="select customized-select dropdown_width_recruiter_invite w100 numericContainer">
                          <PhoneInput
                            international
                            defaultCountry={userInformation.defaultCountryCode}
                            country={userInformation.defaultCountryCode}
                            className="textbox_phone_input"
                            placeholder="Enter phone number"
                            value={userInformation.phoneNumber && userInformation.countryCode ?
                              userInformation.countryCode + userInformation.phoneNumber :
                              userInformation.phoneNumber || ""}
                            onChange={(e) => phoneNumberChangeHandler(e)}
                            onKeyPress={(e) => keypressHandler(e)}
                          />
                          {(!userInformation.isValidPhoneNumber && userInformation.phoneNumber) ? (
                            <p className="form-error fs-regular">
                              Please enter a valid phone number
                            </p>
                          ) : (
                            ""
                          )}
                        </div>
                      </Grid>
                      <Grid size={{ xs: 12, md: 6 }}>
                        <div className="inputLabel_right">State*</div>
                        <Autocomplete
                          id="combo-box-demo"
                          className="mt_14"
                          options={locationList?.stateList}
                          autoHighlight
                          value={userInformation.locationState}
                          getOptionLabel={(option) => option.name || ""}
                          loading={locationList.isStateFetching}
                          filterSelectedOptions
                          onFocus={() => locationList.stateList.length > 0 ? null : fetchLocationInformation("state")}
                          disabled={Object.keys(userInformation.locationCountry).length === 0}
                          onChange={stateHandler}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              required={true}
                              placeholder="Select state"
                              slotProps={{
                                input: {
                                  ...params.InputProps,
                                  endAdornment: (
                                    <>
                                      {locationList.isStateFetching ? <CircularProgress color="inherit" size={20} /> : null}
                                      {params.InputProps.endAdornment}
                                    </>
                                  ),
                                },
                              }}
                            />
                          )}
                        />
                      </Grid>
                      <Grid size={{ xs: 12, md: 6 }}>
                        <div className="inputLabel_right">City</div>
                        <Autocomplete
                          id="combo-box-demo"
                          className="mt_14"
                          options={locationList.cityList}
                          autoHighlight
                          filterSelectedOptions
                          value={userInformation.locationCity}
                          getOptionLabel={(option) => option.name || ""}
                          onFocus={() => locationList.cityList.length > 0 ? null : fetchLocationInformation("city")}
                          disabled = {Object.keys(userInformation.locationState).length === 0}
                          loading={locationList.isCityFetching}
                          onChange={cityHandler}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              required={true}
                              placeholder="Select city"
                              slotProps={{
                                input: {
                                  ...params.InputProps,
                                  endAdornment: (
                                    <>
                                      {locationList.isCityFetching ? <CircularProgress color="inherit" size={20} /> : null}
                                      {params.InputProps.endAdornment}
                                    </>
                                  ),
                                },
                              }}
                            />
                          )}
                        />
                      </Grid>
                      <Grid size={{ xs: 12, md: 6 }}>
                        <div className="inputLabel_right">Test*</div>
                        <Autocomplete
                          id="combo-box-demo"
                          className="mt_8"
                          options={allTests}
                          autoHighlight
                          filterOptions={filterTestOptions}
                          value={defaultTest}
                          disabled
                          getOptionLabel={(option) => option.testName}
                          onChange={testChange}
                          renderInput={(params) => <TextField {...params} variant="outlined" required placeholder="Select a skill" />}
                        />
                      </Grid>
                      <Grid size={{ xs: 12 }}>
                        <div className="termsContainer">
                          <div className="video-interview-chkbox basicinfo_chkbox">
                            <input type="checkbox" id="terms" checked={isTermsAccepted} onClick={(e) => TermsCheckboxHandler(e)} />
                            <label htmlFor="terms"></label>
                          </div>
                          <p className="f-color fs-semi-bold fs-16" > I agree to ClearedTalent's <span className="termsLink" onClick={goToTerms}> Terms of Use </span><span className='text-cyan'> & </span><span className="termsLink" onClick={goToPrivacyPolicy}>Privacy Policy </span></p>
                        </div>
                      </Grid>
                      <Grid size={{ xs: 12 }}>
                        <div className="continue_container">
                          <button onClick={(e) => updateProfileData(e)} className="continue_button">Start Test</button>
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                </Grid>
              </Grid>
            </div>
            <Footer/>
          </div>
        </>
      ) : (
        <>
          {isPageDisplay ? (
            <>
              <div className="mainContainer_reg">
                <div className="topContainer">
                  <div className="nav_bg_home home-specific-header">
                    <div className="container w1200 nav_bg_home_section">
                      <div className="nav_bg_left">
                        <li className='cp headerListStyleNone' onClick={() => gotoHomePage()}>
                          <div><img src={recruiter_header_logo} className="nav_logo_home" alt='img' /></div>
                        </li>
                      </div>
                      <div className="nav_bg_right">
                        <ul className="navbar_home">
                          <li className="special_hover cp" onClick={openSupportModal}><>Contact Us</></li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className='nav_bg_home_responsive'>
                    <div className="nav_bg_home_responsive-wrapper">
                      <div className="home-top-nav">
                        <li className='cp headerListStyleNone' onClick={() => gotoHomePage()}>
                          <div><img src={recruiter_header_logo} className="nav_logo_home" alt='img' /></div>
                        </li>
                        <div className={hamburgerIsClicked ? "hamburgerIsClicked" : "hamburgerIsNotClicked"} ref={hamburger}>
                          <ul className="navbar_home-responsive">
                            <li className="special_hover cp" onClick={openSupportModal}><>Contact Us</></li>
                          </ul>
                        </div>
                        <div className="icon" onClick={hamburgerClicked}>
                          <i className="fa fa-bars"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="section-wrapper">
                    <div className="container w1200 flex-to-footer">
                      <div className="height_adjust mt-110">
                        <Container component={Paper} sx={styles.testQuestAnsCard}>
                          <p className="fs-semi-bold fs-22 f-color mb_16 text-center">
                            The Invited link is invalid or expired
                          </p>
                        </Container>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : null}
        </>
      )}
      <HomeContactUsModal
        modalOpen={open}
        modalClose={_modalClose}
      />
    </>
  );
};

export default RecruiterSignUp;
